import React from 'react';
import { PortableText as OriginalPotableText } from '@portabletext/react';
import PropTypes from 'prop-types';
import Text from '../Text';

function PortableText({ value, components }) {
  return (
    <Text>
      <OriginalPotableText value={value} components={components} />
    </Text>
  );
}

PortableText.propTypes = {
  value: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  components: PropTypes.shape(),
};

PortableText.defaultProps = {
  components: null,
};

export default PortableText;
